import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowExpandHor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowExpandHor"><Path d="M17.5 8L21.5 12L17.5 16" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 8L2.5 12L6.5 16" stroke="currentColor" strokeLinecap="square"/><Path d="M3 12H21" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowExpandHor;
